import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">VendaMotos Honda</h3>
            <p className="text-gray-300 mb-4">
              Especialistas em motos Honda populares com as melhores condições do mercado.
            </p>
            <div className="flex items-center space-x-2 mb-2">
              <Phone size={16} />
              <span>(13) 99676-3208</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail size={16} />
              <span>contato@vendamotoshonda.com</span>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Horário de Funcionamento</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <Clock size={16} />
                <span>Segunda a Sexta: 8h às 18h</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock size={16} />
                <span>Sábado: 8h às 12h</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock size={16} />
                <span>Domingo: Fechado</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Localização</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1" />
                <span>
                  Av. Brasil, 1234<br />
                  Centro - Santos/SP<br />
                  CEP: 11000-000
                </span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Formas de Pagamento</h4>
            <div className="space-y-2 text-gray-300">
              <p>• Cartão de Crédito</p>
              <p>• Entrada + Parcelas</p>
              <p>• Consórcio</p>
              <p>• Financiamento CDC</p>
              <p>• Aposentado/Pensionista</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © 2024 VendaMotos Honda. Todos os direitos reservados.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a
                href="https://wa.me/5513996763208"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm transition-colors"
              >
                WhatsApp
              </a>
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="bg-primary-600 hover:bg-primary-700 text-white px-4 py-2 rounded-lg text-sm transition-colors"
              >
                Voltar ao Topo
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};